@import ../../styles/helpers

header
    z-index: 2
    height: $header_height
    width: 100%
    position: relative
    display: flex
    flex-flow: column nowrap
    align-items: center
    +m
        height: calc( $header_height )
    .fixedContainer
        display: flex
        justify-content: space-between
        padding: 0 $external_margin
        background-color: $page_background
        align-items: center
        height: inherit
        width: inherit
        position: fixed
        max-width: 1450px
        +m
            height: calc( $header_height )
            gap: $external_margin
            padding: calc( $external_margin / 2 )

.chatIcons

    display: none
    +m
        display: block

.header_zone
    height: $icon_size
    display: flex
    justify-content: center
    align-items: center

.left
    margin-right: $external_margin
    +m
        margin: 0

.right
    display: flex
    +m
        display: none
        margin: 0px

.center
    justify-content: space-between
    flex-grow: 1
    gap: $external_margin
    +m
        justify-content: end
        height: $icon_size_m
    
.logo
    height: $icon_size
    img
        height: $icon_size
        border-radius: 20px
    +m
        height: $icon_size_m
        img
            height: $icon_size_m

.searchInputMobile
    display: none
    +m
        display: block
        height: $icon_size_m


.iconsContainer
    display: flex
    height: $header_icon_size
    button
        height: $header_icon_size
    a
        margin-right: 10px
    img
        height: $header_icon_size
        margin-right: 5px
        width: auto
    +m
        display: none
        height: $header_icon_size
        img
            height: $header_icon_size

// OLD

.wrapper
    display: flex
    align-items: center
    flex-grow: 1
    +d
        flex-grow: 1
    +m
        position: absolute
        top: 0
        left: 0
        right: 0
        flex-direction: column
        align-items: stretch
        height: 640px
        margin: 0
        padding: 140px 32px 40px
        box-shadow: 0px 64px 64px rgba(31, 47, 70, 0.2)
        background: $neutrals8
        visibility: hidden
        opacity: 0
        transition: all .2s
        +dark
            background: $neutrals1
        &.active
            visibility: visible
            opacity: 1
    .button
        display: none
        +m
            display: inline-flex
            margin-top: 16px

.nav
    display: flex
    margin-right: auto
    border-left: 2px solid $neutrals6
    display: none
    +m
        display: flex
        flex-direction: column
        margin: 0 0 40px
        border: none
    +dark
        border-color: $neutrals3

.link
    margin-left: 32px
    +dm-sans
    line-height: 40px
    color: $neutrals4
    transition: color .2s
    +m
        margin-left: 0
        font-size: 24px
        line-height: 64px
    &:hover,
    &.active
        color: $blue
    &:nth-child(n+3)
        display: none
        +m
            display: block

.search
    position: relative
    flex-shrink: 0
    width: 420px
    margin-right: 24px
    +x
        width: 350px
    +t
        display: none
    +m
        display: block
        width: 100%
        margin: auto 0 0
    svg
        fill: #FFFFFF
        position: absolute
        top: 14px
        left: 15px

.input
    width: 100%
    height: 58px
    padding: 0 42px 0 54px
    background: none
    border-radius: 25px
    color: #FFFFFF
    background-color: #1B2028
    +snappy
    +body-2
    transition: border-color .2s
    +placeholder
        color: $neutrals4
    +dark
        border-color: $neutrals3
        color: $neutrals8
    &:focus
        border: 2px solid
        border-color: $neutrals4

.result
    position: absolute
    top: 9px
    right: 10px
    bottom: 0
    width: 95px
    height: 40px
    background-color: #2A323D
    border-radius: 25px
    color: #FFFFFF
    +body-2
    svg
        fill: $neutrals4
        transition: fill .2s
    &:hover
        svg
            fill: $blue

.news
    position: relative
    flex-shrink: 0
    margin-left: 16px
    +d
        display: none
    +m
        display: none
        width: 100%
        margin: auto 0 0

    button
        background-color: #443122
        color: white
        height: 57px
        width: 185px
        border-radius: 25px
        padding-left: 40px
        padding-top: 1px
        +body-2
        &:hover
            border: 1px solid
            border-color: #9b704f

.newsicon
    position: absolute
    top: 7px
    left: 7px
    background-color: #DD8A37
    padding: 7px
    border-radius: 150px
    width: 42px
    height: 42px

    svg
        fill: #FFFFFF

.burger
    display: none
    +m
        display: block
        position: relative
        margin-left: 20px
        width: 32px
        height: 32px
        background: none
        -webkit-tap-highlight-color: rgba(0,0,0,0)
        &.active
            &:before
                transform: translateY(0) rotate(-45deg)
            &:after
                transform: translateY(0) rotate(45deg)
        &:before,
        &:after
            content: ''
            position: absolute
            top: 16px
            left: 6px
            width: 20px
            height: 2px
            background: $neutrals4
            border-radius: 2px
            transition: transform .2s
        &:before
            transform: translateY(-4px)
        &:after
            transform: translateY(3px)
